import { GetShiftsByEventCommandOutput, Shift, ShiftTimingType } from '@amzn/red-velvet-api';
import { useAllPagesRedVelvetQuery } from '../allPagesRedVelvetQuery';

export function calculateShiftTime(shift: Shift | undefined, vcCreated?: boolean) {
  if (!shift) return 0;

  if (
    vcCreated &&
    shift.shiftTimingType === ShiftTimingType.FLEXIBLE &&
    shift.shiftLength != null &&
    shift.shiftLength > 0
  )
    return shift.shiftLength;

  const startDate = shift.startDateTime ? new Date(shift.startDateTime) : null;
  const endDate = shift.endDateTime ? new Date(shift.endDateTime) : null;
  if (startDate && endDate) {
    return (endDate.getTime() - startDate.getTime()) / (1000 * 60);
  }
  return 0;
}

export function useShiftTime(eventId: string, shiftId: string, vcCreated?: boolean) {
  // We need the shift information to determine the default length of time for attendance
  const shiftsQuery = useAllPagesRedVelvetQuery({
    redVelvetQueryKey: ['getShiftsByEvent', { eventId }],
    converter: (output: GetShiftsByEventCommandOutput) => ({
      items: output.shifts || [],
      next: output.page,
    }),
  });

  const shift = (shiftsQuery.data || []).find((shift: Shift) => shift.shiftId === shiftId);
  return calculateShiftTime(shift, vcCreated);
}
